import Echo from 'laravel-echo';
import Pusher from 'pusher-js';

import type { BroadcastConfig } from '@/types/global';

declare global {
    interface Window {
        Pusher: typeof Pusher;
    }
}

let echo: Echo<'reverb'> | null = null;

/**
 * Lazily create a single Echo instance connected to Reverb (Pusher protocol).
 */
export function createEcho(config: BroadcastConfig): Echo<'reverb'> {
    if (echo) {
        return echo;
    }

    window.Pusher = Pusher;

    echo = new Echo<'reverb'>({
        broadcaster: 'reverb',
        key: config.key,
        wsHost: config.host,
        wsPort: config.port,
        wssPort: config.port,
        forceTLS: config.scheme === 'https',
        enabledTransports: ['ws', 'wss'],
    });

    return echo;
}

export function destroyEcho(): void {
    if (echo) {
        echo.disconnect();
        echo = null;
    }
}
